import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import CloudinaryImage from '../common/CloudinaryImage';

import Container from './Container';
import './vlinkway.css';

export default function VlinkWay({
  vlinkway,
  grid,
  setModalCall,
  animation,
  bg,
  descolor,
}) {
  return (
    <section
      className={`xl:py-[75px] py-[40px] relative before:z-[1] ${bg} before:content-[""] before:bottom-0 before:left-0 before:absolute before:right-0 before:top-0`}
    >
      {vlinkway?.bgImage?.data?.attributes?.url && (
        <CloudinaryImage
          backendImgUrl={vlinkway?.bgImage?.data?.attributes?.url}
          className={`absolute top-0 bottom-0 left-0 right-0 w-full z-[0] h-full object-cover`}
          alt={vlinkway?.bgImage?.data?.attributes?.alternativeText}
          type="isDesktop"
        />
      )}
      <Container className={`relative z-[1]`}>
        <div className={vlinkway?.titleEditor && 'xl:mb-[34px] mb-[30px]'}>
          {vlinkway?.titleEditor && (
            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              className={`text-center font-[400] xl:text-[48px] md:text-[32px] text-[26px] title_hd leading-tight text-white`}
              source={vlinkway?.titleEditor}
            >
              {vlinkway?.titleEditor}
            </ReactMarkdown>
          )}
          {animation && (
            <div className="relative top-[40px] left-[-30px] z-[1] animateline h-[10px] w-[200px] rounded-[30px] overflow-hidden md:block hidden">
              <span className="h-[10px] w-[100%] rounded-[30px] bg-[#FFA030] absolute delay-150"></span>
            </div>
          )}
          {vlinkway?.description && (
            <p
              className={`text-[${descolor}] text-center font-[400] text-[24px]`}
            >
              {vlinkway?.description}
            </p>
          )}
        </div>
        <div
          className={`backdrop-blur-[10px] relative z-[2] grid xl:grid-cols-${grid} md:grid-cols-2 grid-cols-1 bg-[#FFFFFF08] rounded-[4px] border-[1px] border-[#FFFFFF3D]`}
        >
          {vlinkway?.Reasons?.map((items, key) => (
            <div
              key={items?.id}
              className={`${items?.bgColor && 'hoverbg'} p-[30px] ${key === 0 ? '' : 'md:border-l-[1px]'} border-[#FFFFFF3D] border-dashed`}
            >
              {items?.icon?.data?.attributes?.url && (
                <div className="w-[50px] h-[50px] mb-3">
                  <CloudinaryImage
                    backendImgUrl={items?.icon?.data?.attributes?.url}
                    className="w-full"
                    alt={items?.icon?.data?.attributes?.alternativeText}
                    type="icon"
                  />
                </div>
              )}
              <p className="md:text-[22px] text-[18px] text-[#FFFFFF] font-[700] mb-1">
                {items?.text}
              </p>
              <p className="text-[#FFFFFF] text-[14px] font-[400]">
                {items?.description}
              </p>
            </div>
          ))}
        </div>
        {vlinkway?.btn_text && (
          <div className="text-center">
            <button
              className={`mt-[50px] bg-[#FFA030] text-[#000D3A] border border-[#fff] group h-min relative rounded-[4px] overflow-hidden inline-block px-14 py-2 shadow-[10px_20px_40px_0px_#00000033]`}
              onClick={() => setModalCall(vlinkway?.btn_text)}
            >
              <span
                className={`bg-[#fff] absolute top-0 left-0 flex w-full h-0 mb-0 transition-all duration-200 ease-out transform translate-y-0 group-hover:h-full opacity-1`}
              ></span>
              <span
                className={`lg:text-[24px] text-[14px] group-hover:text-black flex items-center font-[600] relative`}
              >
                {vlinkway?.btn_text}
              </span>
            </button>
          </div>
        )}
      </Container>
      {animation && (
        <div className="absolute top-[5%] z-[1] right-[100px] animatelineheight h-[90%] w-[10px] rounded-[30px] overflow-hidden md:block hidden">
          <span className="h-[100%] w-[10px] rounded-[30px] bg-[#FFA030] absolute delay-150"></span>
        </div>
      )}
    </section>
  );
}
